var map = {
	"./apple.png": "cbad",
	"./apple@2x.png": "c29c",
	"./apple@3x.png": "bd30",
	"./lifesaver.png": "fc30",
	"./lifesaver@2x.png": "7f92",
	"./lifesaver@3x.png": "749b",
	"./money-up.png": "5fe7",
	"./money-up@2x.png": "62c7",
	"./money-up@3x.png": "6c66",
	"./money.png": "018d",
	"./money@2x.png": "268f",
	"./money@3x.png": "5559",
	"./product-wrong.png": "6561",
	"./product-wrong@2x.png": "37d6",
	"./product-wrong@3x.png": "02a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1268";